import styled from "styled-components";


export const Container = styled.div`
  background: linear-gradient(145deg, 
    rgba(26, 26, 46, 0.95) 0%, 
    rgba(22, 33, 62, 0.95) 50%,
    rgba(26, 26, 46, 0.95) 100%
  );
  border-radius: 2rem;
  padding: 3rem;
  position: relative;
  overflow: hidden;
  height: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 2rem;
    padding: 1px;
    background: linear-gradient(135deg, 
      rgba(102, 126, 234, 0.5) 0%, 
      rgba(118, 75, 162, 0.3) 50%, 
      rgba(240, 147, 251, 0.5) 100%
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  h2{
    font-size: 2rem;
    margin-bottom: 2.5rem;
    background: linear-gradient(135deg, #ffffff 0%, #b8b8ff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-align: left;
  }

  form{
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;

    input, textarea{
      width: 100%;
      padding: 1.4rem 1.8rem;
      border-radius: 1.2rem;
      outline: none;
      border: 1px solid rgba(102, 126, 234, 0.3);
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
      color: white;
      font-weight: 500;
      font-size: 1.4rem;
      transition: all 0.3s ease;

      &::placeholder{
        color: #888;
      }

      &:focus {
        border-color: rgba(102, 126, 234, 0.6);
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.12) 0%, rgba(118, 75, 162, 0.12) 100%);
        box-shadow: 0 0 20px rgba(102, 126, 234, 0.2);
      }
    }

    textarea{
      height: 15rem;
      overflow-y: auto;
      resize: none;
      line-height: 1.6;
    }

    .rc-anchor-light {
      border-radius: 1rem !important;
    }

    button{
      padding: 1.4rem 3rem;
      font-size: 1.4rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
      border: none;
      border-radius: 3rem;
      color: white;
      cursor: pointer;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
      margin-top: 1rem;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          90deg,
          transparent,
          rgba(255, 255, 255, 0.2),
          transparent
        );
        transition: left 0.5s ease;
      }

      &:hover:not(:disabled) {
        transform: translateY(-3px);
        box-shadow: 
          0 15px 30px rgba(102, 126, 234, 0.4),
          0 0 40px rgba(240, 147, 251, 0.2);

        &::before {
          left: 100%;
        }
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }

  @media (max-width: 740px){
    padding: 2rem;
    
    form{
      input, textarea{
        padding: 1.2rem 1.5rem;
      }
    }
  }
`


export const ContainerSucces = styled.div`
  background: linear-gradient(145deg, 
    rgba(26, 26, 46, 0.95) 0%, 
    rgba(22, 33, 62, 0.95) 50%,
    rgba(26, 26, 46, 0.95) 100%
  );
  border-radius: 2rem;
  padding: 4rem;
  text-align: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 2rem;
    padding: 1px;
    background: linear-gradient(135deg, 
      rgba(46, 213, 115, 0.5) 0%, 
      rgba(102, 126, 234, 0.3) 50%, 
      rgba(240, 147, 251, 0.5) 100%
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  h3 {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    background: linear-gradient(135deg, #2ed573 0%, #7bed9f 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  button{
    padding: 1.2rem 2.5rem;
    font-size: 1.4rem;
    font-weight: 600;
    text-transform: uppercase;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
    border: none;
    border-radius: 3rem;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 15px 30px rgba(102, 126, 234, 0.4);
    }
  }
`